import createDebugger from 'debug';
export function createLazyDebugger(tag) {
    const debug = createDebugger(tag);
    const f = (cb) => {
        if (debug.enabled) {
            const values = cb();
            if (values.length > 0) {
                debug(...values);
            }
        }
    };
    f.enabled = debug.enabled;
    f.enable = (v) => {
        debug.enabled = v;
    };
    return f;
}
export { createDebugger };
